import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import propTypes from 'prop-types'
import { useAuthRestoration } from '../AuthInitializer';

export const PrivateRoute = ({ children = <></> }) => {
    const { userData } = useSelector((state) => state.auth)
    const { _id, has_access } = userData;
    const { isRestoring } = useAuthRestoration();

    // Wait for auth restoration to complete before redirecting
    // This prevents redirecting to login when auth is being restored from localStorage
    if (isRestoring) {
        return null; // or a loading spinner
    }

    return (
        <>{_id && has_access ? children : !has_access && _id ? <Navigate to="/no-access" /> : <Navigate to="/login" />}</>
    )
}

PrivateRoute.propTypes = {
    children: propTypes.element
}

// DefaultProps removed - using JavaScript default parameters instead